/* Names this page in every message, so the host can ignore the traffic every other
   iframe and extension on the vammo.com home puts on the same `message` event. */
export const EMBED_MESSAGE_SOURCE = 'vammo-station-finder';

type HostMessage = { source: typeof EMBED_MESSAGE_SOURCE; type: 'height'; height: number } | {
  source: typeof EMBED_MESSAGE_SOURCE;
  type: 'lead';
};

/* Any origin. Nothing here is private — a pixel height and the fact that somebody asked
   to be told about a station — and pinning the origin would break every preview host the
   page is checked from before it reaches the home. The half that has to be strict is the
   host's: it must test `event.origin` before it acts on any of this. That check is in the
   snippet the WordPress theme carries. */
const ANY_HOST = '*';

const send = (message: HostMessage): void => {
  try {
    /* The standalone page is its own top window. Posting there would deliver to a
       listener that does not exist, and make a page nobody embedded look embedded. */
    if (window.parent === window) {
      return;
    }
    window.parent.postMessage(message, ANY_HOST);
  } catch {
    // The host is another origin and may refuse. It must never break the lookup.
  }
};

/* The band this page has to deliver in the smallest space is `limited`, whose copy is the
   longest and whose invitation to be notified is the one thing under it. Cutting either
   to fit a 500px section would cut the answer, so the section grows instead: this reports
   what the content actually needs and the host raises its own minimum height. */
export const notifyHostOfHeight = (height: number): void => {
  send({ source: EMBED_MESSAGE_SOURCE, type: 'height', height: Math.ceil(height) });
};

/* The lead is recorded inside the iframe, where the host page's tag manager cannot see
   it. Carries no name and no number: the host has no business with those, and the survey
   already holds them. */
export const notifyHostOfLead = (): void => {
  send({ source: EMBED_MESSAGE_SOURCE, type: 'lead' });
};
